import React from "react";
import { PHONES, SHOP } from "../data/shop";

export const Contact = () => (
  <div className="footer-block">
    <h3 className="footer-block__title">Visit</h3>
    <p className="footer-block__lines">
      <a href={SHOP.mapUrl} target="_blank" rel="noopener noreferrer">
        {SHOP.street}
        <br />
        {SHOP.cityStateZip}
      </a>
    </p>
    <dl className="phones">
      {PHONES.map((phone) => (
        <div className="phones__row" key={phone.href}>
          <dt>{phone.label}</dt>
          <dd>
            <a href={phone.href}>{phone.number}</a>
          </dd>
        </div>
      ))}
    </dl>
    <a
      className="btn-ghost mt-3"
      href={SHOP.mapUrl}
      target="_blank"
      rel="noopener noreferrer"
    >
      Get Directions
    </a>
  </div>
);
